<template>
    <div class="post_main">
        <!-- 标题 -->
        <div class="title">
            <h2>{{ mode == 'edit' ? '修改' : '刊登' }}{{ propertyInfo.rentalType == 1 ? '售' : '租' }}盤</h2>
            <a class="charges" href="/property/charges" target="view_window">收費標準</a>
            <p>
                <!-- isUsedDiamond && isUsedCoin && isUseStandard && isShowCoinHistory&& isShowDiamondHistory  -->
                <template v-if="isUsedDiamond">
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#iconzuanshi" />
                    </svg>
                    <span v-if="accountType && (userInfo.roleID == 1 || userInfo.roleID == 2)">
                        公司賬戶持有House730鑽石：<i>{{ remainderDiamond }}</i></span
                    >
                    <span v-else
                        >個人持有House730鑽石：<i>{{ remainderDiamond }}</i></span
                    >
                    <span class="line" v-if="isUseStandard">/</span>
                </template>
                <template v-if="isUseStandard">
                    <svg class="icon" aria-hidden="true">
                        <use xlink:href="#iconjinbi" />
                    </svg>
                    <span v-if="accountType && (userInfo.roleID == 1 || userInfo.roleID == 2)">
                        公司賬戶持有House730金幣：<i>{{ remainderPropertyCoin }}</i></span
                    >
                    <span v-else
                        >個人持有House730金幣：<i>{{ remainderPropertyCoin }}</i></span
                    >
                </template>
            </p>
            <p><i class="red">*</i>必填</p>
        </div>
        <!-- 楼盘类型 -->
        <el-form :model="propertyInfo" ref="propertyInfo" label-width="155px" class="demo-ruleForm" :rules="rules" @submit.native.prevent>
            <!-- 遮罩层 续期||立即付款 无法修改楼盘信息 -->
            <div class="disable" v-if="mode === '1'"></div>
            <div class="type">
                <h3>樓盤類型</h3>
                <div class="content">
                    <el-row :gutter="20" class="cate">
                        <el-form-item label="樓盤類型" prop="propertyCategory">
                            <el-radio-group v-model="propertyInfo.propertyCategory" class="onlyChoose" :disabled="searchRes && conditions">
                                <el-radio :disabled="item.disable" :label="item.dictionaryValue" v-for="item in diConfig.PropertyCategory" :key="item.dictionaryValue" @change="setChildType(item)">{{ item.dictionaryNameWithCulture }}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item prop="subCategory" v-if="propertyInfo.propertyCategory == 5 || propertyInfo.propertyCategory == 1">
                            <!-- 土地展示多选 -->
                            <el-checkbox-group :disabled="searchRes && conditions" v-model="propertyInfo.subCategory" :max="2" class="moreChoose" v-if="propertyInfo.propertyCategory === '5'">
                                <el-checkbox v-for="citem in diConfig.ChildrenCategory" :label="citem.dictionaryValue" :key="citem.dictionaryValue">{{ citem.dictionaryNameWithCulture }}</el-checkbox>
                            </el-checkbox-group>
                            <!-- 非土地展示单选  -->
                            <el-radio-group v-else :disabled="searchRes && conditions" v-model="propertyInfo.subCategory" class="moreChoose">
                                <el-radio @change="changeSub" :label="item.dictionaryValue" v-for="item in diConfig.ChildrenCategory" :key="item.dictionaryValue">{{ item.dictionaryNameWithCulture }}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-row>
                    <!-- 工商厦 && 嘉丽格 中原 账户 展示-->
                    <!-- 匹配成功后，樓盤物業類型及銷售機會編號不可修改 -->
                    <el-row :gutter="20" class="propertyNo" v-if="propertyInfo.propertyCategory === '2' && (companyCategory == 1 || companyCategory == 2)">
                        <el-form-item label="銷售機會編號" prop="categoryNo">
                            <el-input :disabled="searchRes" v-model="propertyInfo.categoryNo" class="w320" type="text" maxlength="20" @input="saleChange($event)"></el-input>
                            <el-button type="primary" class="w120 left_10" :disabled="!propertyInfo.categoryNo || searchRes" @click="checkRepeat(propertyInfo.categoryNo)">搜尋</el-button>
                            <div class="el-form-item__error" v-if="propertyNoRepeat && propertyInfo.categoryNo">銷售機會編號已經存在</div>
                        </el-form-item>
                        <el-form-item label="物業編號" prop="propertyNo" v-if="!conditions || searchRes" class="mt_10">
                            <el-input :disabled="searchRes" v-model="propertyInfo.propertyNo" @blur="checkRepeat(propertyInfo.propertyNo)" class="w320" type="text" maxlength="20" @input="seaChange($event)"></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row :gutter="20" class="propertyNo" v-else>
                        <el-form-item label="物業編號" prop="propertyNo">
                            <el-input ref="propertyNo" v-model="propertyInfo.propertyNo" v-if="conditions" :disabled="searchRes" class="w320" type="text" maxlength="20" @input="conChange($event)" @keyup.enter.native="checkRepeat(propertyInfo.propertyNo)"></el-input>
                            <el-input ref="propertyNo" v-model="propertyInfo.propertyNo" v-else @blur="checkRepeat(propertyInfo.propertyNo)" class="w320" type="text" maxlength="20" @input="proChange($event)"></el-input>
                            <el-button type="primary" class="w120 left_10" v-if="conditions" :disabled="!propertyInfo.propertyNo || searchRes" @click="checkRepeat(propertyInfo.propertyNo)">搜尋</el-button>
                            <span class="EAA left_10" v-else>EAA要求提供 (最多20字)</span>
                            <!-- 利嘉阁物业同一代理人物业编号不能重复文案-->
                            <div class="el-form-item__error" v-if="propertyNoRepeat && propertyInfo.propertyNo">
                                {{ promptinfo }}
                            </div>
                        </el-form-item>
                    </el-row>
                </div>
            </div>
            <!-- 樓盤地址 -->
            <div class="address" v-if="!conditions || searchRes">
                <h3>樓盤地址</h3>
                <div :class="['content', { disabledbutton: !propertyInfo.propertyCategory }]">
                    <!-- 搜索输入 -->
                    <el-form-item label="屋苑或大廈名稱" prop="estateName" v-if="addressSearch" :disabled="conditions">
                        <el-autocomplete class="w320 left_negative10" :disabled="(mode === 'edit' && !editEst) || mode === '2' || conditions" v-model="propertyInfo.estateName" :fetch-suggestions="search" placeholder="搜尋：屋苑或大廈名稱" @select="setEstate" @blur="cancelSearch"></el-autocomplete>
                        <div class="blues" @click="changeSearch">手動輸入地區屋苑</div>
                        <span class="sign">© 中原樓市片區</span>
                    </el-form-item>
                    <!-- 手动录入信息 -->
                    <div v-if="!addressSearch">
                        <el-form-item label="地區" prop="gscopeFaCode" class="inline_block left_negative15">
                            <el-select v-model="propertyInfo.gscopeFaCode" class="choose left_5" :disabled="(mode === 'edit' && !editEst) || conditions" placeholder="請選擇" no-data-text="暫無數據">
                                <el-option v-for="item in diConfig.gscope" :key="item.gscopeCode" :value="item.gscopeCode" @click.native="setGscope(item)" :label="item.gscopeNameWithCulture"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="樓市片區" prop="gscopeCode" class="inline_block">
                            <el-select v-model="propertyInfo.gscopeCode" class="choose" :disabled="(mode === 'edit' && !editEst) || conditions" placeholder="請選擇" no-data-text="暫無數據">
                                <el-option v-for="item in diConfig.ChildrenGscope" :key="item.gscopeCode" :value="item.gscopeCode" :label="item.gscopeNameWithCulture" @click.native="setChType(item)"> </el-option>
                            </el-select>
                        </el-form-item>
                        <div class="blues" @click="changeSearch">點撃使用搜尋方式輸入地區屋苑較易被客人搜尋到樓盤</div>
                        <span class="sign">© 中原樓市片區</span>
                        <el-form-item label="屋苑或大廈名稱" prop="estateNameAll" class="left_negative15">
                            <el-input prop="estateName" placeholder="請輸入屋苑或大廈中文名稱" :disabled="(mode === 'edit' && !editEst) || conditions" v-model="propertyInfo.estateName" class="w320 left_5" maxlength="30" @input="editSelEstateName" @blur="addDraft('acquireId')"></el-input>
                            <el-input prop="estateNameEN" placeholder="請輸入屋苑或大廈英文名稱" :disabled="(mode === 'edit' && !editEst) || conditions" v-model="propertyInfo.estateNameEN" class="w320 right_5" maxlength="60" @input="editSelEstateName" @blur="addDraft('acquireId')"></el-input>
                        </el-form-item>
                        <!-- <div class="estateNameEN"> -->
                        <!-- <span class="left_10 tip">中文</span> -->
                        <!-- <span class="left_10 tip">英文</span> -->
                        <!-- </div> -->
                    </div>
                    <template v-if="addressSearch">
                        <!-- 期数 搜索且输入了屋苑名称非村务(客制)时显示 && (propertyInfo.estateName && estAdress.phaseEstates.length)-->
                        <el-row v-if="addressSearch && !isCutomadded && propertyInfo.propertyCategory !== 5 && estAdress.phaseEstates.length" :gutter="20">
                            <el-form-item label="期數" prop="phaseWithCulture" :rules="propertyInfo.propertyCategory == 1 && editNewDataRule ? rules.phaseWithCulture : [{ required: false }]">
                                <el-select class="w200" :disabled="conditions" v-model="propertyInfo.phaseWithCulture" placeholder="請選擇期數" no-data-text="暫無數據">
                                    <el-option v-for="(item, index) in estAdress.phaseEstates" :key="index" :label="item.phaseWithCulture" :value="item.phaseWithCulture" @click.native="setPhaBuild('phase', item)"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-row>
                        <!-- 座数 楼层 -->
                        <el-row v-if="propertyInfo.propertyCategory !== '4' && propertyInfo.propertyCategory !== '5'" :gutter="20" class="flexbuilA-flo">
                            <div class="flexbuilA">
                                <!-- propertyInfo.propertyCategory == 1 && !isCutomadded && showEstAdressbui && editNewDataRule -->
                                <el-form-item label="座數" prop="buildingNameWithCulture" :rules="isHaveTo ? rules.buildingNameWithCulture : [{ required: false }]">
                                    <!-- 村务客制手输 -->
                                    <el-select v-if="!isCutomadded && showEstAdressbui && propertyInfo.propertyCategory !== '3'" class="w150" :disabled="conditions" v-model="propertyInfo.buildingNameWithCulture" placeholder="請選擇座數" no-data-text="暫無數據">
                                        <el-option v-for="(item, index) in estAdress.buildings" :key="index" :label="item.buildingNameWithCulture" :value="item.buildingNameWithCulture" @click.native="setPhaBuild('build', item)"> </el-option>
                                    </el-select>
                                    <el-input v-if="isCutomadded || !showEstAdressbui || propertyInfo.propertyCategory == '3'" :disabled="conditions" v-model="propertyInfo.buildingName" class="w150" @blur="setPhaBuild('isCusbuild')"></el-input>

                                    <!-- 根据buildingID进行判断座数 -->
                                    <!-- <el-select v-if="!isCutomadded && showEstAdressbui && propertyInfo.propertyCategory !== '3'" class="w150" :disabled="conditions" v-model="propertyInfo.buildingNameWithCulture" placeholder="請選擇座數" no-data-text="暫無數據">
                                        <el-option v-for="(item, index) in estAdress.buildings" :key="index" :label="item.buildingNameWithCulture" :value="item.buildingID" @click.native="setPhaBuild('build', item)"> </el-option>
                                    </el-select> -->
                                </el-form-item>
                            </div>
                            <div ref="unitFloor" class="flexflo">
                                <el-form-item label="樓層" class="build-form" prop="floorNameAll" :rules="propertyInfo.propertyCategory == '1' && propertyInfo.buildingType == 1 && editNewDataRule ? rules.floorName : [{ required: false }]">
                                    <div class="build-Div build-Div-flo">
                                        <template v-if="propertyInfo.propertyCategory == '1' && propertyInfo.buildingType == 1">
                                            <!-- propertyInfo.floorNameWithCulture -->
                                            <el-select prop="floorName" class="w150" :disabled="conditions || oneBuilFlo || startFloDis" v-model="propertyInfo.floorName" placeholder="請選擇樓層" no-data-text="暫無數據">
                                                <!-- item.floorDisplay ? item.floorNameWithCulture : item.floorName -->
                                                <!-- item.floorNameWithCulture ? item.floorNameWithCulture : item.floorName -->
                                                <el-option v-for="(item, index) in estAdress.floorList" :key="index" :label="item.floorName" :value="item.floorName" @click.native="setFlo(item)"> </el-option>
                                            </el-select>
                                            <!-- {{propertyInfo.unitFloor}}-{{propertyInfo.floorName?propertyInfo.floorName.indexOf('(')==-1:false}}--{{estAdress.floorList.length?estAdress.floorList[0].floorNameWithCulture.indexOf('(')==-1:false}} -->
                                            <!-- || (mode == 'edit' && (propertyInfo.floorName.indexOf('(')==-1||estAdress.floorList.length?estAdress.floorList[0].floorNameWithCulture.indexOf('(')==-1:false)) -->
                                            <el-select v-if="estAdress.unitFloorList.length" prop="unitFloor" class="w150 build-sel" :disabled="conditions || oneBuilFlo" v-model="propertyInfo.unitFloor" placeholder="請選擇高/中/低層" no-data-text="暫無數據">
                                                <el-option v-for="(item, index) in estAdress.unitFloorList" :key="index" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue" @click.native="setFloExt"></el-option>
                                            </el-select>
                                            <el-select v-else class="w150 build-sel" :disabled="conditions || oneBuilFlo || propertyInfo.buildingType == 1" v-model="propertyInfo.unitFloor" placeholder="請選擇高/中/低層" no-data-text="暫無數據">
                                                <el-option v-for="item in diConfig.UnitFloor" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue" @click.native="selPlatImg('101')"> </el-option>
                                            </el-select>
                                            <el-tooltip v-if="false || !estAdress.unitFloorList.length" popper-class="ye-vr" placement="top">
                                                <div slot="content">
                                                    <p>根據總樓層數量除以3，分為高/中/低層</p>
                                                </div>
                                                <img class="imgTip" src="../../../assets/hovertip.svg" alt="" />
                                            </el-tooltip>
                                        </template>
                                        <template v-else>
                                            <el-select :disabled="conditions || oneBuilFlo || startFloDis" v-model="propertyInfo.unitFloor" placeholder="請選擇高/中/低層" no-data-text="暫無數據" class="w180">
                                                <el-option v-for="item in diConfig.UnitFloor" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue" @click.native="setFloExt"> </el-option>
                                            </el-select>
                                            <span class="starTips" v-if="propertyInfo.propertyCategory == '2'">星級盤必須選擇</span>
                                        </template>
                                    </div>
                                </el-form-item>
                            </div>
                        </el-row>
                        <!-- 车位楼层 -->
                        <el-row v-if="addressSearch && propertyInfo.propertyCategory == '4'" :gutter="20">
                            <el-form-item label="樓層">
                                <el-select :disabled="conditions" v-model="propertyInfo.unitFloor" placeholder="請選擇高/中/低層" no-data-text="暫無數據" class="w180">
                                    <el-option v-for="item in diConfig.UnitFloor" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue" @click.native="setFloExt"> </el-option>
                                </el-select>
                            </el-form-item>
                        </el-row>
                        <!-- 单位 -->
                        <el-row v-if="propertyInfo.propertyCategory !== '4' && propertyInfo.propertyCategory !== '5'" :gutter="20">
                            <el-form-item v-if="propertyInfo.propertyCategory == '1' && propertyInfo.buildingType == 1" label="單位">
                                <el-select class="w200" :disabled="conditions || oneBuilRoom || startBuilRoom" v-model="propertyInfo.roomNo" placeholder="請選擇單位" no-data-text="暫無數據">
                                    <el-option v-for="(item, index) in estAdress.unitList" :key="index" :label="item.roomNoWithCulture" :value="item.roomNo" @click.native="setRoomNo"> </el-option>
                                </el-select>
                            </el-form-item>
                            <!-- 独立屋等(234)手输单位 -->
                            <el-form-item v-else label="單位">
                                <!-- :disabled="conditions || oneBuilRoom || startBuilRoom" -->
                                <el-input :disabled="conditions" v-model="propertyInfo.roomNo" maxlength="20" class="w120" @blur="setRoomNo"></el-input>
                            </el-form-item>
                        </el-row>
                        <div v-if="propertyInfo.propertyCategory == '1' && (propertyInfo.buildingNameWithCulture || propertyInfo.buildingName) && companyCategory == 3" class="top-est">樓盤資料絕對保密，樓層會以高/中/低層顯示{{ propertyInfo.rentalType == 1 ? '，用於快將推出的估價功能(如有)' : '' }}</div>
                    </template>

                    <template v-else>
                        <!-- 期数 -->
                        <!-- <el-row :gutter="20">
                            <el-form-item label="期數">
                                <el-input class="w200" v-model="propertyInfo.phaseWithCulture"  @blur="setOneEstData"></el-input>
                            </el-form-item>
                        </el-row> -->
                        <!-- 座数 楼层-->
                        <el-row v-if="propertyInfo.propertyCategory !== '5'" :gutter="20" class="flexbuilA-flo">
                            <div v-if="propertyInfo.propertyCategory !== '4'" class="flexbuilA">
                                <el-form-item label="座數">
                                    <el-input :disabled="conditions || (mode == 'edit' && !editNewDataRule)" v-model="propertyInfo.buildingName" class="w150" @blur="setOneEstData"></el-input>
                                </el-form-item>
                            </div>
                            <div ref="unitFloor" :class="['flexflo', { flexCat: propertyInfo.propertyCategory == 4 }]">
                                <el-form-item label="樓層" class="build-form">
                                    <el-select :disabled="conditions" v-model="propertyInfo.unitFloor" placeholder="請選擇高/中/低層" no-data-text="暫無數據" class="w180">
                                        <el-option v-for="item in diConfig.UnitFloor" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue" @click.native="setOneEstData"> </el-option>
                                    </el-select>
                                    <span class="starTips" v-if="propertyInfo.propertyCategory == '1' || propertyInfo.propertyCategory == '2'">星級盤必須選擇</span>
                                </el-form-item>
                            </div>
                        </el-row>
                        <!-- 单位 -->
                        <el-row v-if="propertyInfo.propertyCategory !== '5' && propertyInfo.propertyCategory !== '4'" :gutter="20">
                            <el-form-item label="單位" class="build-form">
                                <el-input v-model="propertyInfo.roomNo" maxlength="20" class="w120" @blur="setOneEstData"></el-input>
                            </el-form-item>
                        </el-row>
                    </template>
                    <!-- 樓盤資料顯示 -->
                    <el-row class="est-data" v-if="propertyDisPlayList.length && companyCategory != 1" :gutter="20" :disabled="conditions">
                        <span v-if="propertyInfo.propertyCategory == '1'" class="starMust">*</span>
                        <el-form-item label="樓盤資料顯示">
                            <div class="re-est">你的樓盤資料將會以此顯示在House730</div>
                            <el-radio-group @change="$forceUpdate()" class="est-radio" v-if="propertyDisPlayList.length > 1" v-model="propertyInfo.propertyDisPlayType">
                                <el-radio v-for="item in propertyDisPlayList" :label="item.PropertyDisPlayType" :key="item.PropertyDisPlayType">
                                    {{ item.estDatawithCulture }}
                                </el-radio>
                            </el-radio-group>
                            <div class="est-tit" v-if="propertyDisPlayList.length == 1">
                                <span v-for="item in propertyDisPlayList" :key="item.PropertyDisPlayType">
                                    {{ item.estDatawithCulture }}
                                </span>
                            </div>
                        </el-form-item>
                    </el-row>
                    <!-- 樓盤地址 楼龄 -->
                    <el-row :gutter="20" :disabled="conditions">
                        <el-form-item label="街道號碼">
                            <el-input :placeholder="!addressSearch ? ' 如:天湖路1號' : ''" :disabled="addressSearch || conditions || (!Boolean(propertyInfo.estateId) && mode !== 'post' && mode !== 'copy')" v-model="propertyInfo.estateAddress" maxlength="20" class="w120"></el-input>
                            <el-tooltip v-if="!addressSearch" popper-class="ye-vr" placement="top">
                                <div slot="content">
                                    <p>所輸入的內容，將會在樓盤詳情頁顯示，請不要輸入完整地址</p>
                                </div>
                                <img class="imgTip" src="../../../assets/hovertip.svg" alt="" />
                            </el-tooltip>
                            <div v-if="propertyInfo.propertyCategory != '5'" class="build-Div">
                                <span>樓齡</span>
                                <el-input @input="onlyNumber(propertyInfo.buildingAge, 'buildingAge')" :disabled="addressSearch || JSON.stringify(EstateInfo) != '{}' || conditions" v-model="propertyInfo.buildingAge" maxlength="20" class="w120"></el-input>
                            </div>
                        </el-form-item>
                    </el-row>
                    <!-- 房間數目 -->
                    <el-row v-if="propertyInfo.propertyCategory !== '4' && propertyInfo.propertyCategory !== '5'" :gutter="20" ref="roomNumber" :disabled="conditions">
                        <el-form-item label="房間數目">
                            <el-select :disabled="conditions" v-model="propertyInfo.roomNumber" placeholder="不提供" no-data-text="暫無數據" class="w180">
                                <el-option v-for="item in diConfig.RoomNumber" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue" placeholder="不提供"> </el-option>
                            </el-select>
                            <span class="starTips" v-if="isUsedDiamond && propertyInfo.propertyCategory == 1">星級盤必須選擇</span>
                            <div v-if="propertyInfo.propertyCategory !== '2' && propertyInfo.propertyCategory !== '3'" class="build-Div">
                                <span>洗手間數目</span>
                                <el-select :disabled="conditions && disSelToil" v-model="propertyInfo.toiletNumber" placeholder="不提供" no-data-text="暫無數據" class="w180">
                                    <el-option v-for="item in diConfig.ToiletNumber" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue" @click.native="changeToilet(item)" placeholder="不提供"> </el-option>
                                </el-select>
                            </div>
                        </el-form-item>
                    </el-row>
                </div>
            </div>
            <!-- 银行估价 && (!conditions || searchRes)-->
            <div v-if="bankVal && isShowBoc && propertyInfo.rentalType == 1">
                <div class="ageHide">
                    <div class="ageTitle">
                        <h3>銀行估價</h3>
                    </div>
                    <div class="content">
                        <el-row :gutter="20">
                            <el-form-item label="銀行估價">
                                <el-checkbox v-model="propertyInfo.isBoc"></el-checkbox>
                                <span style="font-size: 14px">&nbsp;&nbsp;開啟</span>
                                <div class="bankques">開啟後，用戶可在樓盤詳情頁中使用銀行估價功能（如有）<br/>即時物業估值服務由中國銀行(香港)有限公司委託第三方提供，僅供參考。</div>
                            </el-form-item>
                        </el-row>
                        <div style="margin-left:160px" v-if="showBankAll"> 
                            <div class="bankAll">即時物業估值</div>
                            <template v-if="showBankEva">
                                <div class="evaboxo">
                                    <img src="../../../assets/post-bank.png" alt="##">
                                    <el-button v-if="showEvaBut" type="primary" :disabled="!evalue" @click="geteva">即時物業估值</el-button>
                                    <el-button v-else style="background-color:#990033;border-color:#990033;color:#ffffff">樓價估值 ${{evaluationValue}}萬</el-button>
                                    <div v-if="!showEvaBut">估價日期：{{evaluationDate}}</div>
                                </div>
                                <div class="evaboxt" v-if="showAgreeEva">
                                    <div class="checkdiv"><el-checkbox v-model="evalue"></el-checkbox></div>
                                    <div>本人/本人等已閱讀及明白中國銀行（香港）有限公司的即時物業估值<br/>服務之 <a class="bocCla" target="_blank" href="https://www.bochk.com/dam/mortgage/valuation_tnc_tc.pdf">條款及細則</a>，並同意受其約束。<br/>此即時物業估值服務由中國銀行（香港）有限公司委託第三方提供，<br/>僅供參考。</div>
                                </div>
                                <div class="tipdiv" v-else>此即時物業估值服務由中國銀行(香港)有限公司委託第三方提供，僅供參考。</div>
                            </template>
                            <template v-else>
                                <div class="hbox">即時物業估值</div>
                                <div class="imgtipbox">
                                    <img src="../../../assets/post-warning.png" alt="" />
                                    <span>我們暫時未能為你提供所需的即時物業估值。</span>
                                </div>
                            </template>
                        </div>    
                    </div>
                </div>
            </div>
            <!-- 樓盤價格及面積 -->
            <div class="area" v-if="!conditions || searchRes">
                <h3>樓盤價格及面積</h3>
                <div class="content">
                    <el-row :gutter="20" v-if="propertyInfo.rentalType == 1">
                        <el-form-item v-if="propertyInfo.subCategory !== '6' && propertyInfo.subCategory !== '7'" label="放售價" prop="salePrice">
                            <el-input ref='elsalePrice' class="w120" v-model="propertyInfo.salePrice" type="text" maxlength="12" @input="onlyNumber(propertyInfo.salePrice, 'salePrice')" @blur="Unit('sale', propertyInfo.salePrice)"></el-input>
                            <span class="grayW left_10">萬元</span>
                        </el-form-item>
                        <el-form-item prop="paidSalePrice" :rules="propertyInfo.subCategory == '6' || propertyInfo.subCategory == '7' ? rules.paidSalePrice : [{ required: false }]" v-show="propertyInfo.subCategory == '6' || propertyInfo.subCategory == '7'" label="放售價">
                            <span class="normal">未補地價</span>
                            <el-input class="w150 left_16" type="text" maxlength="12" v-model="propertyInfo.unPaidSalePrice" @input="onlyNumber(propertyInfo.unPaidSalePrice, 'unPaidSalePrice')" @blur="isShowReaduce('unPaidSalePrice','firstUnPaidSalePrice','isReduceUnpaid','isReduceUnPaidSalePrice')"></el-input>
                            <span class="gray left_10 right_50">萬元</span>
                            <span class="normal">已補地價</span>
                            <el-input  class="w150 left_16" type="text"  maxlength="12" v-model="propertyInfo.paidSalePrice" @input="onlyNumber(propertyInfo.paidSalePrice, 'paidSalePrice')" @blur="isShowReaduce('paidSalePrice','firstPaidSalePrice','isReducePaid','isReducePaidSalePrice')"></el-input>
                            <span class="gray left_10">萬元</span>
                        </el-form-item>
                    </el-row>
                    <el-row v-else :gutter="20">
                        <el-form-item label="放租價" prop="rentPrice">
                            <el-input class="w120" v-model="propertyInfo.rentPrice" maxlength="12" @input="onlyNumber(propertyInfo.rentPrice, 'rentPrice')" @blur="Unit('rent', propertyInfo.rentPrice)"></el-input>
                            <span class="red left_10">每月租金</span>
                        </el-form-item>
                    </el-row>
                    <el-row class="inputVr" v-if="showReducePrice" :gutter="20">
                        <el-form-item label="">
                            <span class="inputVr-label">減價盤</span>
                            <el-tooltip popper-class="ye-vr" placement="top">
                                <div slot="content">
                                    <p>選擇後會在House730顯示減<br/>價比率, 最大比率為30%</p>
                                </div>
                                <img class="imgTip" src="../../../assets/hovertip.svg" alt="" />
                            </el-tooltip>
                            <el-checkbox v-if="isReduceUnpaid" v-model="propertyInfo.isReduceUnPaidSalePrice">開啟(未補)</el-checkbox>
                            <span v-if="isReduceUnpaid && isReducePaid" class="inputVr-label">減價盤</span>
                            <el-tooltip v-if="isReduceUnpaid && isReducePaid" popper-class="ye-vr" placement="top">
                                <div slot="content">
                                    <p>選擇後會在House730顯示減<br/>價比率, 最大比率為30%</p>
                                </div>
                                <img class="imgTip" src="../../../assets/hovertip.svg" alt="" />
                            </el-tooltip>
                            <el-checkbox v-if="isReducePaid" v-model="propertyInfo.isReducePaidSalePrice">開啟{{propertyInfo.subCategory == '6' || propertyInfo.subCategory == '7'?'(已補)':''}}</el-checkbox>
                            <el-checkbox v-if="rentReducePrice" v-model="propertyInfo.isReduceRentPrice">開啟</el-checkbox>
                        </el-form-item>
                    </el-row>
                    
                    <!-- 建築/實用 面積 -->
                    <el-row :gutter="20" v-if="propertyInfo.propertyCategory !== '4'">
                        <el-form-item label="面積(呎)" prop="buildingArea">
                            <span class="normal">實用</span>
                            <el-input class="w150 right_50 left_10" :disabled="conditions" v-model="propertyInfo.saleableArea" maxlength="12" @input="onlyNumber(propertyInfo.saleableArea, 'saleableArea')"></el-input>
                            <span class="normal">建築</span>
                            <el-input class="w150 left_10 right_10 " :disabled="conditions" v-model="propertyInfo.buildingArea" maxlength="12" @input="onlyNumber(propertyInfo.buildingArea, 'buildingArea')"></el-input>
                            <div class="inline-tip" v-if="(propertyInfo.subCategory == '11' && propertyInfo.propertyCategory ==1) || (propertyInfo.propertyCategory && propertyInfo.propertyCategory!='1' && propertyInfo.propertyCategory !='4')">
                                <el-checkbox v-model="isArea">面積未核實</el-checkbox>
                                <el-tooltip popper-class="ye-vr" placement="top">
                                    <div slot="content">
                                        <p>如面積未核實，<br/>須註明並會在House730網頁上顯示。</p>
                                    </div>
                                    <img class="imgTip left_10" src="../../../assets/hovertip.svg" alt="" />
                                </el-tooltip>
                            </div>
                        </el-form-item>
                    </el-row>
                    <!-- 起租日 -->
                    <el-row :gutter="20" v-if="propertyInfo.rentalType == 2">
                        <el-form-item label="起租日" prop="beginRentTime">
                            <el-date-picker :disabled="conditions" class="w180" v-model="propertyInfo.beginRentTime" type="date" placeholder="可隨時起租" value-format="timestamp"></el-date-picker>
                        </el-form-item>
                    </el-row>
                    <!-- 其他選項 -->
                    <el-row :gutter="20" v-if="propertyInfo.rentalType == 2 && propertyInfo.propertyCategory != '4' && propertyInfo.propertyCategory != '5'">
                        <el-form-item label="其他選項">
                            <el-checkbox-group v-model="propertyInfo.rentLabel">
                                <el-checkbox v-for="item in diConfig.RentLabel" :label="item.dictionaryValue" :key="item.dictionaryValue" :disabled="disRentLabel(item)">
                                    {{ item.dictionaryNameWithCulture }}
                                    <el-popover popper-class="hoverTip" placement="top-start" width="10" trigger="hover" content="服務式住宅租期至少在一個月以上，一年之內；由業主提供裝修，廚房，傢俬在內的全套家居設備，以及服務及維修在內的中央管理。">
                                        <img class="imgTip" @click.prevent="tipService" v-if="item.dictionaryValue == 5" slot="reference" src="../../../assets/hovertip.svg" alt="" />
                                    </el-popover>
                                </el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-row>
                    <!-- 每月管理費 -->
                    <!-- <el-row :gutter="20" v-if="propertyInfo.propertyCategory != '4'">
                        <el-form-item label="每月管理費">
                            <el-col :span="2">
                                <el-input :disabled="conditions" v-model="propertyInfo.propertyManagementFee" maxlength="6" @input="onlyNumber(propertyInfo.propertyManagementFee, 'propertyManagementFee')"></el-input>
                            </el-col>
                            <el-col :span="1">
                                <span class="maxLength">元</span>
                            </el-col>
                        </el-form-item>
                    </el-row> -->
                </div>
            </div>
            <!-- 平面图  住宅 选了屋苑 且有平面图-->
            <div class="planImg" v-if="(propertyInfo.floorName || propertyInfo.roomNo) && propertyInfo.estateID && propertyInfo.propertyCategory == 1 && (!conditions || searchRes) && propertyInfo.buildingType == 1">
                <div class="pImg_tit">
                    <h3>平面圖</h3>
                    <span class="ques">＠House730提供</span>
                </div>
                <div class="content">
                    <!-- 有筛选项但无数据时 -->
                    <div v-if="alreaSel == true" style="height: 120px">
                        <div class="wudata">
                            <img src="@/assets/wudata.svg" />
                            <span>暫時未有提供相關平面圖，我們正努力製作中</span>
                        </div>
                    </div>
                    <div v-if="platUrls.length !== 0 && alreaSel == false" class="plaImgBox">
                        <div class="imgbox" v-for="(url, index) in platUrls" :key="index">
                            <div class="imgxixi">
                                <el-image @click="changeP(url, index)" style="width: 180px; height: 180px" lazy :src="url.imagePath + '?x-oss-process=style/300xauto_f'"> </el-image>
                                <el-checkbox @change="changeCheck" class="planbox" :label="url" v-model="planChecked"> <br /> </el-checkbox>
                            </div>
                            <div>單位平面圖</div>
                        </div>
                        <el-dialog class="bigimgdia" title="提示" :visible.sync="aPlat">
                            <el-carousel class="postCar" trigger="click" indicator-position="none" :initial-index="nPlat" v-if="aPlat == true" height="560px" direction="horizontal" :autoplay="false">
                                <el-carousel-item v-for="(it, index) in platUrls" :key="index">
                                    <img :src="it.imagePath + '?x-oss-process=style/640x480_c'" alt="" />
                                    <div class="medium">{{ it.imageDesc }}</div>
                                </el-carousel-item>
                            </el-carousel>
                            <img style="width: 39px; height: 46px; z-index: 2088; position: absolute; top: -15px; right: -51px" @click="changePdia('plat')" src="@/assets/guanbi.svg" />
                        </el-dialog>
                    </div>
                    <!-- 楼层平面图 -->
                    <div v-if="floUrls.length !== 0 && alreaSel == false" class="plaImgBox">
                        <div class="imgbox" v-for="(url, index) in floUrls" :key="index">
                            <!-- :preview-src-list="floPlaturls(index)" -->
                            <div class="imgxixi">
                                <el-image ref="elimage" @click="changeF(url, index)" style="width: 180px; height: 180px" lazy :src="url.imagePath + '?x-oss-process=style/300xauto_f'"> </el-image>
                                <el-checkbox class="planbox" @change="changeFloCheck" :label="url" v-model="planfloChecked"> <br /> </el-checkbox>
                            </div>
                            <div>樓層平面圖</div>
                        </div>
                        <el-dialog class="bigimgdia" title="提示" :visible.sync="aFlor">
                            <el-carousel class="postCar" trigger="click" indicator-position="none" :initial-index="nFlor" v-if="aFlor == true" height="560px" direction="horizontal" :autoplay="false">
                                <el-carousel-item v-for="(it, index) in floUrls" :key="index">
                                    <img :src="it.imagePath + '?x-oss-process=style/640x480_c'" alt="" />
                                    <div class="medium">{{ it.imageDesc }}</div>
                                </el-carousel-item>
                            </el-carousel>
                            <img style="width: 39px; height: 46px; z-index: 2088; position: absolute; top: -15px; right: -51px" @click="changePdia('flo')" src="@/assets/guanbi.svg" />
                        </el-dialog>
                    </div>
                </div>
            </div>
            <!-- 樓盤資料 -->
            <div class="data" v-if="!conditions || searchRes">
                <h3>樓盤資料</h3>
                <div class="content">
                    <el-row :gutter="20" ref="titleCN">
                        <el-form-item label="放盤標題" prop="titleCN" ref="titleCN">
                            <!-- 失焦判断是否含有敏感词 (PMS06修改标题空格规则.trim) -->
                            <el-input v-model="propertyInfo.titleCN" type="text" maxlength="30" class="w500" @input="sensitive('titleCN', propertyInfo.titleCN)">
                                <span slot="suffix" class="commonWord" @click="openCommon(1)">選擇常用詞</span>
                            </el-input>
                            <span class="maxLength left_10">中文（最多30字）</span>
                            <div class="el-form-item__error" v-if="propertyInfo.titleCN && hasSenWrods.titleCN">內容不符合會員條款無法刊登</div>
                            <span class="starTips" v-if="isUsedDiamond">星級盤中文標題必須不少於8個字</span>
                        </el-form-item>
                    </el-row>
                    <el-row :gutter="20">
                        <el-form-item label="" prop="titleEN">
                            <el-input v-model="propertyInfo.titleEN" class="w500 left_20" @input="sensitive('titleEN', propertyInfo.titleEN)"> </el-input>
                            <span class="maxLength left_10" type="text" maxlength="50">英文（最多50字）</span>
                            <div class="el-form-item__error" v-if="propertyInfo.titleEN && hasSenWrods.titleEN">內容不符合會員條款無法刊登</div>
                        </el-form-item>
                    </el-row>
                    <el-row :gutter="20">
                        <el-form-item label="樓盤介紹" prop="introduceCN">
                            <el-input v-model="propertyInfo.introduceCN" type="textarea" maxlength="300" resize="none" class="w500 introduceCN" @input="sensitive('introduceCN', propertyInfo.introduceCN)"></el-input>
                            <span class="maxLength left_10" type="text" maxlength="30">中文（最多300字）</span>
                            <i class="commonWord wordPos" @click="openCommon(2)">選擇常用詞</i>
                            <div class="el-form-item__error" v-if="propertyInfo.introduceCN && hasSenWrods.introduceCN">內容不符合會員條款無法刊登</div>
                        </el-form-item>
                    </el-row>
                    <el-row :gutter="20" style="height: 95px">
                        <el-form-item label="">
                            <el-input v-model="propertyInfo.introduceEN" type="textarea" maxlength="600" resize="none" class="w500 left_20" @input="sensitive('introduceEN', propertyInfo.introduceEN)"></el-input>
                            <span class="maxLength left_10" type="text" maxlength="50">英文（最多600字）</span>
                            <div class="el-form-item__error" v-if="propertyInfo.introduceEN && hasSenWrods.introduceEN">內容不符合會員條款無法刊登</div>
                        </el-form-item>
                    </el-row>
                </div>
            </div>

            <!-- 楼盘标签(!conditions || searchRes) &&  -->
            <div class="protags" v-if="propertyInfo.propertyCategory !== '5' && (!conditions || searchRes) ">
                <div class="tags_tit">
                    <h3>樓盤標籤</h3>
                </div>
                <div class="content">
                    <el-row :gutter="20" class="cate cateone" v-if="propertyInfo.propertyCategory == '' || !propertyInfo.propertyCategory || propertyInfo.propertyCategory == '1' || propertyInfo.propertyCategory == '2' ">
                        <div v-if="isFirst" class="jiachewei">
                            <div class="guifea">
                                <span>單位特色</span>
                                <span>最多選擇4個</span>
                                <span><input type="checkbox" disabled id="check1" />連車位</span>
                            </div>
                            <span><input type="checkbox" disabled id="check1" />連車位</span>
                            <span><input type="checkbox" disabled id="check1" />連花園</span>
                            <span><input type="checkbox" disabled id="check1" />連露台</span>
                            <span><input type="checkbox" disabled id="check1" />連天台</span>
                            <span><input type="checkbox" disabled id="check1" />連平台</span>
                            <span><input type="checkbox" disabled id="check1" />連租約</span>
                            <span><input type="checkbox" disabled id="check1" />複式</span>
                            <span><input type="checkbox" disabled id="check1" />全層</span>
                            <span><input type="checkbox" disabled id="check1" />相連</span>
                        </div>
                        <el-form-item v-if="!isFirst" label="單位特色">
                            <span class="tags_geshu">最多選擇4個</span>
                            <el-checkbox-group @change="changeChar" v-model="tagsChar" :max="4" class="moreChoose moreChooseone charBox" :disabled="propertyInfo.propertyCategory == '' || !propertyInfo.propertyCategory">
                                <el-checkbox :class="`devicPosition${s}`" v-for="(citem, s) in diConfig.ChildrenTag[0]" :label="citem.dictionaryValue" :key="citem.dictionaryValue">{{ citem.dictionaryNameWithCulture }}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-row>
                    <el-row :gutter="20" class="cate" v-if="propertyInfo.propertyCategory == '' || !propertyInfo.propertyCategory || propertyInfo.propertyCategory == '1' || propertyInfo.propertyCategory == 2">
                        <el-form-item label="景觀">
                            <span class="tags_geshu">最多選擇1個</span>
                            <el-checkbox-group @change="changeSce" v-model="tagsSce" :max="1" class="moreChoose" :disabled="propertyInfo.propertyCategory == '' || !propertyInfo.propertyCategory">
                                <el-checkbox v-for="citem in diConfig.ChildrenTag[1]" :label="citem.dictionaryValue" :key="citem.dictionaryValue">{{ citem.dictionaryNameWithCulture }}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-row>
                    <el-row :gutter="20" class="cate" v-if="propertyInfo.propertyCategory == '' || !propertyInfo.propertyCategory || propertyInfo.propertyCategory !== '4'">
                        <el-form-item label="裝修">
                            <span class="tags_geshu">最多選擇1個</span>
                            <el-checkbox-group @change="changeRen" v-model="tagsRen" :max="1" class="moreChoose" :disabled="propertyInfo.propertyCategory == '' || !propertyInfo.propertyCategory">
                                <el-checkbox v-for="citem in diConfig.ChildrenTag[2]" :label="citem.dictionaryValue" :key="citem.dictionaryValue">{{ citem.dictionaryNameWithCulture }}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-row>
                    <el-row :gutter="20" class="cate" v-if="propertyInfo.propertyCategory !== '4'">
                        <el-form-item label="配套">
                            <span class="tags_geshu">最多選擇3個</span>
                            <el-checkbox-group @change="changeMat" v-model="tagsMat" :max="3" class="moreChoose" :disabled="propertyInfo.propertyCategory == '' || !propertyInfo.propertyCategory">
                                <el-checkbox :disabled="citem.dictionaryValue == 23 && subway > 15" v-for="citem in diConfig.ChildrenTag[3]" :label="citem.dictionaryValue" :key="citem.dictionaryValue">
                                    <p v-if="citem.dictionaryValue == 23" style="color: red; display: inline-block">#</p>
                                    {{ citem.dictionaryNameWithCulture }}
                                </el-checkbox>
                            </el-checkbox-group>
                            <span v-if="addressSearch && subway != -1 && Object.keys(EstateInfo).length" class="tags_sub"
                                ><p style="color: red; display: inline-block">#</p>
                                註：步行往港鐵站約{{ subway }}分鐘，步行時間是由系統計算出來的，當步行時間在15分鐘內，可選擇＂近港鐵＂標籤</span
                            >
                        </el-form-item>
                    </el-row>
                    <el-row :gutter="20" class="cate" v-if="propertyInfo.propertyCategory == '' || !propertyInfo.propertyCategory || propertyInfo.propertyCategory == '2'">
                        <el-form-item label="工商專用">
                            <span class="tags_geshu">最多選擇3個</span>
                            <el-checkbox-group @change="changeBus" v-model="tagsBus" :max="3" class="moreChoose" :disabled="propertyInfo.propertyCategory == '' || !propertyInfo.propertyCategory">
                                <el-checkbox v-for="citem in diConfig.ChildrenTag[4]" :label="citem.dictionaryValue" :key="citem.dictionaryValue">{{ citem.dictionaryNameWithCulture }}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-row>
                    <el-row :gutter="20" class="cate" v-if="propertyInfo.propertyCategory == '' || !propertyInfo.propertyCategory || propertyInfo.propertyCategory == '4'">
                        <el-form-item label="配套(車位專用)">
                            <span class="tags_geshu">最多選擇6個</span>
                            <el-checkbox-group @change="changePark" v-model="tagsPark" :max="6" class="moreChoose charBox" :disabled="propertyInfo.propertyCategory == '' || !propertyInfo.propertyCategory">
                                <el-checkbox :disabled="citem.dictionaryValue == 51 && subway > 15" v-for="citem in diConfig.ChildrenTag[5]" :label="citem.dictionaryValue" :key="citem.dictionaryValue">
                                    <p v-if="citem.dictionaryValue == 51" style="color: red; display: inline-block">#</p>
                                    {{ citem.dictionaryNameWithCulture }}
                                </el-checkbox>
                                <span v-if="propertyInfo.propertyCategory == '4' && addressSearch && subway != -1 && Object.keys(EstateInfo).length" class="tags_subpark"
                                    ><p style="color: red; display: inline-block">#</p>
                                    註：步行往港鐵站約{{ subway }}分鐘，步行時間是由系統計算出來的，當步行時間在15分鐘內，可選擇＂近港鐵＂標籤</span>
                            </el-checkbox-group>
                        </el-form-item>
                    </el-row>
                    <div :class="['link-top',propertyInfo.propertyCategory == '4'?'link-topPark':'']"></div>
                    <div class="tag_tit">
                        <div class="tag_red">
                            <span>已選標籤</span>
                            <span>（只會顯示前五個標籤在樓盤列表頁）</span>
                            <span class="tag_gra">按住可拖動標籤調整順序，列表與詳情頁根據順序顯示</span>
                        </div>
                    </div>
                    <div class="tag_box">
                        <draggable chosenClass="chosen" @end="tagEnd" v-model="selectedTags" :disabled="draggableStart">
                            <transition-group>
                                <div class="tags_warp" v-for="(item, index) in selectedTags" :key="index">
                                    <span :class="['el-tags']" v-text="item.val"></span>
                                </div>
                            </transition-group>
                        </draggable>
                    </div>
                </div>
            </div>
            <!-- 上傳樓盤圖片 -->
            <div class="pic" v-if="!conditions || searchRes" ref="images">
                <div class="pic_tit">
                    <h3>{{ conditions ? '選擇' : '上傳' }}樓盤圖片</h3>
                    <!-- <span class="tip">如現在沒有照片，可以在修改樓盤時加回。</span> -->
                </div>
                <div class="content">
                    <!-- 左侧文字描述 -->
                    <div class="desc">
                        <h4>圖片</h4>
                        <p class="text">
                            <span>第一張是封面圖</span>
                            <span>你已{{ conditions ? '選擇' : '上載' }}圖片{{ images.length }}</span>
                            <span>你還可以{{ conditions ? '選擇' : '上載' }}圖片{{ 20 - images.length }}</span>
                        </p>
                    </div>
                    <div class="qrCode" v-if="mode != '1'">
                        <div class="code" ref="qrCodeDiv"></div>
                        <p>使用手機掃瞄QR Code，<br />可即時從手機上傳圖片</p>
                    </div>
                    <!-- 按钮 -->
                    <div :class="{ btnLine: true, zybtnLine: conditions }">
                        <div class="starPicTips">
                            <div>
                                <span class="imgstar" v-if="isUsedCoin && isUseStandard">標準盤</span>
                                <span class="imgstar" v-if="isUsedDiamond && isUseSuper">{{ isUsedCoin && isUseStandard ? '/' : '' }}精選盤</span>
                                <span class="imgstar" v-if="(isUsedDiamond && isUseSuper) || (isUsedCoin && isUseStandard)"> - 上載至少1張圖片</span>
                            </div>
                            <div class="imgstar" v-if="isUsedDiamond && isUseStar">星級盤 - 上載至少3張圖片</div>
                        </div>
                        <!-- 上傳我的圖片-->
                        <el-button type="primary" plain class="chooseBtn right_10" v-if="conditions" @click="selectImgShow = true">選擇公司圖片</el-button>
                        <el-upload class="avatar-uploader" :http-request="upimg" action="#" accept="image/jpeg,image/jpg,image/png" :fileList="file" :show-file-list="false" :on-exceed="handleExceed" :limit="20" multiple :before-upload="beforeUpload">
                            <el-button type="primary" plain class="chooseBtn" v-if="conditions">上傳我的圖片</el-button>
                            <el-button type="primary" plain class="chooseBtn" v-else>選擇文件</el-button>
                        </el-upload>
                        <div class="c_button">
                            <el-button type="primary" plain @click="rotate(selectedImage[0], images[selectedImage[0]].imagePath, 270)" :disabled="selectedImage.length === 0 || selectedImage.length > 1">
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#iconzuoxuanzhuan" />
                                </svg>
                                旋轉
                            </el-button>
                            <el-button type="primary" plain @click="rotate(selectedImage[0], images[selectedImage[0]].imagePath, 90)" :disabled="selectedImage.length === 0 || selectedImage.length > 1">
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#iconyouxuanzhuan" />
                                </svg>
                                旋轉
                            </el-button>
                            <el-button type="primary" plain @click="delPic()" :disabled="selectedImage.length === 0">
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#iconshanchu" />
                                </svg>
                                删除
                            </el-button>
                            <el-button type="primary" :disabled="selectedImage.length === 0 || selectedImage.length > 1" plain @click="editPic( images[selectedImage[0]].imagePath)">
                                <svg class="icon" aria-hidden="true">
                                    <use xlink:href="#iconbianjitupian" />
                                </svg>
                                編輯
                            </el-button>
                            <el-button type="primary" plain :disabled="selectedImage.length === 0 || selectedImage.length > 1" @click="largeImg"> <i class="el-icon-zoom-in"></i> 放大 </el-button>
                        </div>
                    </div>
                    <!-- 图片 -->
                    <div class="image">
                        <draggable v-model="images" :disabled="draggableStart" @update="dragUpdate">
                            <transition-group>
                                <div class="img_warp" v-for="(item, index) in images" :key="index">
                                    <div class="el-image" @click="selected(index)" :class="{ selected: selectedImage.includes(index) }">
                                        <img :src="item.localPath || item.imagePath + '?x-oss-process=style/300xauto_f'" alt width="180" height="135" />
                                        <span v-if="item.localPath && !item.imagePath" class="up-loading">{{ curQueue.file.localPath == item.localPath ? '上傳中' : '列隊中' }}</span>
                                        <span v-else-if="!item.localPath && !item.imagePath" class="up-loading">
                                            上傳失敗
                                            <br />請刪除
                                        </span>
                                        <span v-else>加載失敗</span>
                                    </div>
                                    <svg class="icon icon_left" aria-hidden="true" @click="goTop(index, item)">
                                        <use xlink:href="#iconxia" />
                                    </svg>
                                    <svg class="icon icon_right" aria-hidden="true" @click="goNext(index, item)">
                                        <use xlink:href="#iconxia" />
                                    </svg>
                                    <el-select v-model="item.imageType" placeholder="圖片位置" no-data-text="暫無數據">
                                        <el-option v-for="item in diConfig.PropertyImageType" :key="item.dictionaryValue" :label="item.dictionaryNameWithCulture" :value="item.dictionaryValue" @click.native="sendSocket"></el-option>
                                    </el-select>
                                    <el-input v-model="item.imageDesc" placeholder="圖片描述" maxlength="50" @blur="sendSocket" class="descWidth" type="textarea" :autosize="{ minRows: 3, maxRows: 3 }"></el-input>
                                </div>
                            </transition-group>
                        </draggable>
                    </div>
                </div>
            </div>

            <!-- 樓盤视频 -->
            <div class="video" v-if="!conditions || searchRes">
                <div class="vd_tit">
                    <h3>樓盤影片</h3>
                    <span class="ques">請輸入YouTube或Facebook網站的影片連結</span>
                </div>
                <div class="content">
                    <el-row :gutter="30">
                        <el-form-item label="影片封面">
                            <el-col :span="5" class="uploadvideo">
                                <!-- :file-list="videos" -->
                                <el-upload action="#" accept="image/jpeg,image/gif,image/png" :show-file-list="false" :http-request="upvideoImage">
                                    <el-button size="small" @click="upcol()" :type="buttonup">上傳圖片</el-button>
                                </el-upload>
                                <el-button size="small" :type="buttondel" class="delbtn" @click="delVideoImage">刪除</el-button>
                            </el-col>
                        </el-form-item>
                    </el-row>
                    <div class="el_upload" v-if="videos !== null">
                        <!-- <i class="el-icon-close" v-if="!isHidden"  @click="delVideoImage"></i> -->
                        <img v-if="isHidden" src="./../../../assets/PMS_vid .png" />
                        <div class="vid_text" v-else-if="videos[0].defaultImagePath == ''">圖片正在上傳中</div>
                        <div class="vid_text" v-else-if="videos[0].defaultImagePath == '...'">圖片上傳失敗</div>
                        <img class="v_img" v-else :src="videos[0].defaultImagePath + '?x-oss-process=style/300xauto_f'" />
                    </div>

                    <el-row :gutter="20">
                        <div v-if="isFirst" class="vidput">
                            <div class="vidputs">
                                <span>影片連結</span>
                                <input type="text" placeholder="請輸入影片連結" />
                            </div>
                        </div>
                        <el-form-item v-if="videos !== null && !isFirst" label="影片連結" prop="videoVal">
                            <el-input class="w500" placeholder="請輸入影片連結" v-model="videos[0].videoPath" @input="videoLink($event)"></el-input>
                        </el-form-item>
                    </el-row>
                </div>
            </div>
            <template v-if="(!conditions || searchRes) && (isaddVR || InputVR)">
                <div class="vrHide">
                    <div class="vrTitle">
                        <h3>樓盤VR</h3>
                        <!-- <span class="ques">如需要加入VR，物業編號必須正確</span> -->
                    </div>
                    <div class="content">
                        <el-row v-if="isaddVR" :gutter="20" style="height: auto">
                            <!-- <span class="spanHidevr">&nbsp;</span> -->
                            <span class="spanHidevr">綁定樓盤VR</span>
                            <el-checkbox v-model="propertyInfo.addVR" class="textHide"></el-checkbox>
                            <span style="font-size: 16px">&nbsp;&nbsp;有VR&nbsp;&nbsp;&nbsp;</span>
                            <div class="titbox">
                                <span class="vrWarn">加入VR須輸入正確物業編號，因系統處理需時，完成後會在PMS730內通知<br /></span>
                                <span class="vrWarn">如數天後仍未加入，請WhatsApp到 5726 6308 與客戶服務聯絡</span>
                            </div>
                        </el-row>
                        <el-row v-if="InputVR" class="inputVr" :gutter="20">
                            <el-form-item prop="vrVal" label="">
                                <span class="inputVr-label">VR連結</span>
                                <el-tooltip popper-class="ye-vr" placement="top">
                                    <div slot="content">
                                        <p class="ye-vrtext" style="color: #e1c999; font-size: 14px">支援的VR連結格式如下：</p>
                                        <p v-for="(item, index) in vrRules[0].urlPrefix" :key="index">{{ item }}</p>
                                    </div>
                                    <img class="imgTip" src="../../../assets/hovertip.svg" alt="" />
                                </el-tooltip>
                                <el-input v-model="propertyInfo.inputVRURL" class="w500" placeholder="請輸入VR連結"></el-input>
                            </el-form-item>
                        </el-row>
                    </div>
                </div>
            </template>
            <!-- 星级盘显示隐藏 -->
            <template v-if="(!conditions || searchRes) && isUseHideAgent">
                <div class="ageHide">
                    <div class="ageTitle">
                        <h3>代理公司資料</h3>
                    </div>
                    <div class="content">
                        <el-row :gutter="20">
                            <span class="spanHide">&nbsp;</span>
                            <el-checkbox v-model="propertyInfo.isHideAgent" class="textHide"></el-checkbox>
                            <span style="font-size: 16px">&nbsp;&nbsp;隱藏</span>
                            <span class="hideques">&nbsp;&nbsp;只會顯示代理聯絡電話，代理牌照，不會顯示公司名稱，地址，公司電話，公司牌照及公司標誌</span>
                        </el-row>
                    </div>
                </div>
            </template>
            <!-- 代理人选择 -->
            <template v-if="!conditions || searchRes">
                <div class="proxy" v-for="(item, index) in propertyUserInfo" :key="index">
                    <div class="title">
                        <h3>代理人</h3>
                        <span class="el-form-item__error" v-show="isEmpty_agent || draftlen">必須揀選一位代理人</span>
                    </div>
                    <div class="content">
                        <el-row :gutter="20">
                            <el-form-item label="代理人">
                                <el-select v-model="agent[index]" placeholder="請選擇代理人" class="choose" @change="setAgent(index, agent[index])" no-data-text="暫無數據">
                                    <el-option v-for="(agentItem, index) in diConfig.agentList" :key="index" :label="agentItem.name" :value="agentItem.accountID" :disabled="agent.includes(agentItem.accountID) || centaline"></el-option>
                                </el-select>
                                <!-- 中原账户只能选择一个代理人 所以此处不展示 + 号-->
                                <span class="icons">
                                    <svg class="icon icon_add" aria-hidden="true" @click="addProxy(index)" v-show="index !== 2 && companyCategory != 1">
                                        <use xlink:href="#iconjia" />
                                    </svg>
                                    <svg class="icon icon_delete" aria-hidden="true" @click="delProxy(index)" v-show="index !== 0">
                                        <use xlink:href="#iconjian" />
                                    </svg>
                                </span>
                            </el-form-item>
                        </el-row>
                        <el-row :gutter="20">
                            <el-form-item label="電話">
                                <el-col :span="5">
                                    <el-input v-model="item.telephone" class="w320" disabled></el-input>
                                </el-col>
                            </el-form-item>
                        </el-row>
                        <el-row :gutter="20">
                            <el-form-item label="個人地產代理牌照">
                                <el-col :span="5">
                                    <el-input v-model="item.license" class="w320" disabled></el-input>
                                </el-col>
                            </el-form-item>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="3" class="text_right serve">
                                <el-checkbox v-model="item.isJoinAgentIntroduce" @click.native.prevent="specialServe(item.isJoinAgentIntroduce, index)"></el-checkbox>
                                <span>代理個人署名<br />或特別服務</span>
                            </el-col>
                            <el-col :span="5">
                                <el-input class="w320" disabled :value="item.isJoinAgentIntroduce ? item.signature : ''"></el-input>
                            </el-col>
                        </el-row>
                    </div>
                    <!-- </el-form-item> -->
                </div>
            </template>
            <!-- 備註 -->
            <div class="proRemark" v-if="!conditions || searchRes">
                <div class="postWay_tit">
                    <h3 id="remarks">備註</h3>
                </div>
                <div class="content">
                    <div style="margin-left: 122px">
                        <span class="beizhu">備註</span>
                        <el-input class="textinput" type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" v-model="propertyInfo.propertyRemark" maxlength="100"></el-input>
                        <span class="zishu">最多100字</span>
                        <span class="ques">不會公開</span>
                    </div>
                </div>
            </div>
            <!--放盤方式  -->
            <div class="postWay" v-if="!conditions || searchRes">
                <div class="postWay_tit">
                    <h3>放盤方式</h3>
                    <span class="ques">如對付款或放盤有問題，歡迎致電査詢：3619-3200，星期一至五，上午9時到下午6時。</span>
                </div>
                <!-- 标准盘 精选盘修改的时候隐藏掉展示  精选盘复制的时候手动修改数据定位在标准盘上 -->
                <div class="content" v-if="!(propertyInfo.topType == 2 && mode == 'edit')">
                    <el-row :gutter="30" v-if="(mode !== 'edit' && isUseStandard && Object.keys(diConfig.Normal).length) || (mode == 'edit' && Object.keys(diConfig.Normal).length && propertyInfo.topType == '0')">
                        <el-col :span="3" class="text_right">
                            <el-radio @click.native="chooseNormal" label="0" v-model="propertyInfo.topType" :disabled="mode === 'edit' || mode === '1' || mode === '2'">標準盤</el-radio>
                        </el-col>
                        <!-- <el-col :span="5">
                            現在有
                            <i class="num">{{ diConfig.properUsing.normalPropertyRentCount + diConfig.properUsing.normalPropertySaleCount }}</i>
                            個盤使用中
                        </el-col> -->
                        <el-col :span="7" class="introd">
                            <i class="title"> 一般放盤：</i> <i class="price">{{ diConfig.Normal.discountPropertyCoin }}金幣</i>
                        </el-col>
                        <el-col :span="6">有效期：售盤{{ diConfig.Normal.effectiveDays }}天 / 租盤{{ diConfig.Normal.rentEffectiveDays }}天</el-col>
                    </el-row>
                    <!--可以放精选盘了又,利用isUseSuper.替换isUsedDiamond || propertyInfo.topType == '3' //利嘉阁和中原 不能放精选盘   废弃字段v-if="!isProhibitPublishGoldTop"-->
                    <el-row :gutter="30" v-if="(mode !== 'edit' && isUseSuper && Object.keys(diConfig.GoldTop).length) || (mode == 'edit' && Object.keys(diConfig.GoldTop).length && propertyInfo.topType == '1')">
                        <el-col :span="3" class="text_right">
                            <el-radio label="1" v-model="propertyInfo.topType" :disabled="mode === 'edit' || mode === '1' || mode === '2'">精選盤</el-radio>
                        </el-col>
                        <el-col :span="7" class="introd">
                            <i class="title">比標準盤更有效曝光：</i>
                            <i class="price">{{ diConfig.GoldTop.diamond }}鑽石</i>
                        </el-col>
                        <el-col :span="6">有效期：售盤{{ diConfig.GoldTop.effectiveDays }}天 / 租盤{{ diConfig.GoldTop.rentEffectiveDays }}天</el-col>
                    </el-row>
                    <!-- 星級盤  || propertyInfo.topType == '1' -->
                    <el-row :gutter="30" v-if="(mode !== 'edit' && isUseStar && diConfig.Star) || (mode == 'edit' && diConfig.Star && propertyInfo.topType == '3')">
                        <el-col :span="3" class="text_right">
                            <el-radio label="3" v-model="propertyInfo.topType" :disabled="mode === 'edit' || mode === '1' || mode === '2'">星級盤</el-radio>
                        </el-col>
                        <el-col :span="7" class="introd">
                            <i class="title">比精選盤及標準盤有較高曝光機會：</i>
                            <i class="price">{{ diConfig.Star.diamond }}鑽石</i>
                        </el-col>
                        <el-col :span="6">有效期：售盤{{ diConfig.StarSale.effectiveDays }}天 / 租盤{{ diConfig.StarRent.rentEffectiveDays }}天</el-col>
                    </el-row>
                </div>
                <!-- 楼盘验证 废弃 -->
                <!-- 附加（增值）選項 标准盘不允许楼盘验证 -->
                <!-- <div class="Attach" v-if="isUsedDiamond && propertyInfo.topType != 0">
                    <p class="tit">附加（增值）選項</p>
                    <div class="content_sencend">
                        <el-row :gutter="20">
                            <el-form-item label-width="0" prop="isVerify">
                                <el-col :span="3" class="text_right serve">
                                    <el-checkbox v-model="propertyInfo.isVerify" @change="Verify" :disabled="mode === 'edit' || mode === '1' || (mode === '2' && apiData.isVerify)"></el-checkbox>
                                    <span>樓盤驗證</span>
                                </el-col>
                                <el-col :span="7">樓盤詳情顯示為「已驗證」，加強買家/租戶信心</el-col>
                                <el-col :span="4" class="left_negative15">{{ diConfig.VerifyLabel.diamond }}鑽石</el-col>
                                <el-col :span="3" v-show="!(mode === '2' && apiData.isVerify) && propertyInfo.isVerify && (mode !== 'edit' ||( mode == 'edit' && showPropVerify)) && mode !== '1'"><span class="file" @click="attachVisible = true">樓盤驗證文件</span></el-col>
                            </el-form-item>
                        </el-row>
                    </div>
                </div> -->
            </div>
            <!-- 選擇支付方式 -->
            <template v-if="mode !== 'edit'">
                <div class="pay" v-if="!conditions || searchRes">
                    <h2 class="payway">付款詳情</h2>
                    <!-- 只有标准盘可以金币放盘 -->
                    <div class="icon" v-if="propertyInfo.topType == 0">
                        <div class="icon_img"></div>
                        <span class="total">{{ totalPrice }}金幣</span>
                    </div>
                    <div class="icon" v-else>
                        <div class="icon_diamond"></div>
                        <span class="total">{{ totaldiamond }}鑽石</span>
                    </div>
                </div>
            </template>
            <el-form-item label="" prop="agree" class="agree" v-if="!conditions || searchRes">
                <el-checkbox v-model="propertyInfo.agree"></el-checkbox>
                <span>已閱讀及同意</span><a href="/property/terms" target="view_window">放盤條款</a>
            </el-form-item>
            <!-- 立即放盤 -->
            <div class="quickly" v-if="!conditions || searchRes">
                <!-- <el-button type="primary" size="medium" :disabled="disablePost" @click="draft" v-if="(mode === 'post' || mode === 'copy') && !conditions">儲存草稿</el-button> -->
                <el-button type="danger" size="medium" :loading="disablePost" @click="validation('propertyInfo')" v-if="mode === 'edit'">{{ disablePost ? '提交中' : '提交更改' }}</el-button>
                <el-button type="info" size="medium" @click="removeEdit" v-if="mode === 'edit'">取消更改</el-button>
                <el-button type="danger" size="medium" :disabled="disPostBut" :class="[{ disbutgray: disPostBut }]" :loading="disablePost" @click="validation('propertyInfo')" v-else>{{ disablePost ? '提交中' : propertyInfo.rentalType == '1' ? '立即放售盤' : '立即放租盤' }}</el-button>
                <div v-if="mode != 'edit' && (propertyInfo.estateName||propertyInfo.estateNameEn)" class='butBot'>已自動儲存草稿</div>
                <!-- <div :class="mode == '1' ? 'centerBut' : 'draftTip'" v-if="disPostBut && mode !== 'edit'">
                    <div v-if="mode !== '1'">請先儲存草稿</div>
                    <div>如需購買金幣或鑽石，請與我們的營業代表聯絡</div>
                </div> -->
            </div>
            <div :class="['postTip', { zypostTip: conditions }]" v-show="disablePost && (mode === 'post' || mode === 'copy')">放盤提交中 請勿重新載入頁面</div>
        </el-form>
        <!--  附加（增值）選項 弹窗 :before-close="handleClose"   -->
        <!-- <el-dialog :before-close="quit" title="樓盤驗證" :visible.sync="attachVisible" width="45%" center class="dialog_attach">
            <p>請上傳樓盤的委託放盤證明、確實地址、業權證明及其他相關資料，或將相關資料WhatsApp到 5726 6308，我們會在3個工作天內完成審核。</p>
            <br />
            <p>如果你是業主，請提供電費單/水費單/差餉。</p>
            <br />
            <p>如果你是代理，請提供委託放盤證明及其他相關資料。</p>
            <el-upload :fileList="verifyFile" :disabled="verifyFile.length > propertyInfo.verifyImage.length" class="upload-demo" multiple action="#" accept="image/jpeg,image/jpg,image/png" :show-file-list="false" :limit="3" :http-request="upVerifyImage" :on-exceed="handleExceed" :before-upload="beforeUpload">
                <el-button size="small" type="primary" class="upBtn" :disabled="verifyFile.length > propertyInfo.verifyImage.length">上傳圖片</el-button>
                <p style="color:#e50113;font-size:12px;position:absolute" v-if="showEditerror">請上傳樓盤驗證文件</p>
            </el-upload>
            <span class="more">最多3張</span>
            <div class="verifyImg">
                <span v-for="(item, index) in propertyInfo.verifyImage" :key="item">
                    <img :src="pub.imgResize(item, 'user')" alt="" width="100" height="75" />
                    <i class="el-icon-close" @click="delVerifyImage(index)"></i>
                </span>
                <i class="red left_10" v-show="verifyFile.length > propertyInfo.verifyImage.length">圖片正在上傳中</i>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="quit">取 消</el-button>
                <el-button type="primary" @click="conVerifyImage">確 認</el-button>
            </span>
        </el-dialog> -->
        <!-- 付款提示框 -->
        <el-dialog class="payPopup" title="使用House730金幣" :visible.sync="tip" width="30%" left :before-close="quitPay">
            <div class="tip_text">
                <p>
                    <span>放盤方式</span>:
                    {{ propertyInfo.topType === '0' ? '標準盤' : propertyInfo.topType === '1' ? '精選盤' : '星級盤' }}
                    {{ propertyInfo.isVerify ? '、樓盤驗證' : '' }}
                </p>
                <p><span>付款總額</span>: {{ propertyInfo.topType === '0' ? totalPrice + '金幣' : totaldiamond + '鑽石' }}</p>
                <p>請確認放盤資料及付款</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="quitPay">取 消</el-button>
                <el-button type="primary" @click="debounce(sendData(), 500)">確 認</el-button>
                <!-- <el-button type="primary" @click="sendData()">確 認</el-button> -->
            </span>
        </el-dialog>

        <!-- 查看大图 -->
        <div class="enLarge" v-if="enLarge">
            <span class="el-image-viewer__btn el-image-viewer__close" @click="enLarge = false"><i class="el-icon-circle-close"></i></span>
            <span class="el-image-viewer__btn el-image-viewer__prev" @click="changeImg('prev')"><i class="el-icon-arrow-left"></i></span>
            <span class="el-image-viewer__btn el-image-viewer__next" @click="changeImg('next')"><i class="el-icon-arrow-right"></i></span>
            <div class="el-image-viewer__canvas">
                <img :src="images[selectedImage[0]].imagePath + '?x-oss-process=style/master'" ref="bigImg" class="el-image-viewer__img" />
            </div>
        </div>
        <!-- 中原利嘉阁选择图片弹窗 -->
        <el-dialog title="選擇圖片" :visible.sync="selectImgShow" width="70%" class="chooseImg" :close-on-click-modal="false">
            <p v-if="getConImgae">圖片獲取中...</p>
            <ul>
                <li v-for="(item, index) in propertyInfo.imageExternal" :key="index">
                    <i class="seleceted base" v-show="selList.indexOf(item.imagePath) >= 0" @click="addSelected(item)">{{ selList.indexOf(item.imagePath) + 1 }}</i>
                    <i class="unselected base" @click="addSelected(item)"></i>
                    <img :src="item.imagePath" alt="" @click="addSelected(item)" />
                    <!-- <img :src="item.imagePath.indexOf('house730') > -1 ? `${item.imagePath}?x-oss-process=style/master` : item.imagePath" alt="" @click="addSelected(item)" /> -->
                </li>
            </ul>
            <div slot="footer" class="dialog-footer">
                <span class="tiptxt">你已選擇圖片：{{ images.length }} 還可選擇圖片：{{ 20 - images.length }}</span>
                <el-button type="primary" @click="preview">預覽已選圖片</el-button>
                <el-button type="primary" @click="done">完成 ({{ images.length }})</el-button>
            </div>
        </el-dialog>
        <el-image-viewer v-if="enLarge1" :on-close="closeViewer" class="enLarge" :url-list="selList" />

        <!-- 选择关键词对话框 :before-close="handleClose"-->
        <el-dialog :title="Words.dialogTitle" :visible.sync="commonWords" width="60%" class="commonWords">
            <el-checkbox-group v-model="Words.checkedTitle" :max="5" v-if="Words.flag == 1 && BusinessWords.flag == 1">
                <div style="margin-bottom: 10px; font-weight: 700; font-size: 20px">一般常用詞</div>
                <el-checkbox v-for="(item, index) in Words.title" :key="index" :label="item.chinese">{{ item.chinese }}</el-checkbox>
                <div style="margin-top: 20px; margin-bottom: 10px; font-weight: 700; font-size: 20px">工商專用常用詞</div>
                <el-checkbox v-for="item in BusinessWords.title" :key="item.chinese" :label="item.chinese">{{ item.chinese }}</el-checkbox>
            </el-checkbox-group>
            <el-checkbox-group v-model="Words.checkedIntr" :max="10" v-if="Words.flag == 2 && BusinessWords.flag == 2">
                <div style="margin-bottom: 10px; font-weight: 700; font-size: 20px">一般常用詞</div>
                <el-checkbox v-for="(item, index) in Words.Introduction" :key="index" :label="item.chinese">{{ item.chinese }}</el-checkbox>
                <div style="margin-top: 20px; margin-bottom: 10px; font-weight: 700; font-size: 20px">工商專用常用詞</div>
                <el-checkbox v-for="item in BusinessWords.Introduction" :key="item.chinese" :label="item.chinese">{{ item.chinese }}</el-checkbox>
            </el-checkbox-group>
            <span slot="footer" class="dialog-footer">
                <el-button @click="wordQuit">取 消</el-button>
                <el-button type="primary" @click="confirmWord">確 認</el-button>
            </span>
        </el-dialog>

        <!-- 精选盘最少上传一张 -->
        <el-dialog :visible.sync="showTopImage" width="30%" class="showTopImage">
            <p v-if="propertyInfo.topType == 3">刊登星級盤要求</p>
            <span v-html="ruleInfo"></span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="showTopImage = false">確 認</el-button>
            </span>
        </el-dialog>

        <!-- 尚未注册 -->
        <el-dialog :visible.sync="showLogin" width="30%" class="showTopLogin" :before-close="closeLogin">
            <div class="title"><i class="el-icon-warning-outline"></i><span>你登入IBS的電郵，尚未註冊PMS賬戶</span></div>
            <span class="content">請與你的主管聯絡</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="closeLogin">確 定</el-button>
            </span>
        </el-dialog>

        <!-- 刊登分數 -->
        <el-dialog :show-close="true" :before-close="quitSub" :close-on-click-modal="false" title="曝光等級提示" :visible.sync="postScoreVisible" width="35%" class="showpostScore">
            <div>在相同放盤方式下，你的樓盤曝光等級：</div>
            <div class="starbox">
                <span class="starimg" v-for="index in postScore.scoreStar" :key="index">
                    <img src="../../../assets/scorestar.svg" alt="##" />
                </span>
                <span class="starimg" v-for="index in 4 - postScore.scoreStar" :key="index + 'score'">
                    <img src="../../../assets/scorestar_gray.svg" alt="##" />
                </span>
                <span class="redTit">&nbsp;&nbsp;({{ postScore.scoreAdRank }})</span>
            </div>
            <div v-if="postScore.score !== '250'">
                <div v-if="postScore.scoreReason.length">你可以嘗試以下內容提升等級</div>
                <div class="pointF" v-for="(item, index) in postScore.scoreReason" :key="index">
                    <div class="orderpoint"></div>
                    &nbsp;&nbsp;&nbsp;{{ item }}
                </div>
            </div>
            <div class="titVr">如想獲得最高等級，必須加入VR，如有興趣拍攝VR，請與我們的營業代表聯絡</div>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="postScore.score !== '250'" type="primary" class="btrad" @click="quitSub">好的，去調整</el-button>
                <el-button type="danger" class="btrad" @click="goonSub">{{ mode == 'edit' ? '確認修改' : '繼續放盤' }}</el-button>
            </span>
        </el-dialog>
        <el-dialog title="素材编辑" :modal-append-to-body="false" :append-to-body="true" :visible.sync="editImgDialogVisible" class="edit_image_dialog" width="1000px" height:="1000px" :close-on-click-modal="false" >
            <div id="tui-image-editor"></div>
            <span slot="footer" class="dialog-footer" style="margin-top:-20px">
                <span class="editImgcla">建議編輯範圍少於三分之一。超出範圍有可能令客人無法清晰瀏覽。 </span>
                <el-button @click="editImgDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="uploadEditImg(selectedImage[0])">完 成</el-button>
            </span>
        </el-dialog>
        <!-- 修改楼盘验证提示 -->
        <!-- <el-dialog title="樓盤驗證失效提示" :before-close="conVerify" :visible.sync="verifyVisible" width="35%" class="showpostScore" :close-on-click-modal="false">
            <div>因為你修改過以下任何一個資料，樓盤驗證會失效，我們需要重新審核</div>
            <div class="pointF" v-for="(item,index) in verifyExpire"  :key="index"><div class="orderpoint"></div>&nbsp;&nbsp;&nbsp;{{item}}</div>
            <div class="titVr">請問需要重新提交樓盤驗證嗎？</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="conVerify">否</el-button>
                 <el-button type="primary" @click="goonVeify">是</el-button>
            </span>
        </el-dialog> -->
    </div>
</template>
<script>
import postCore from './postCore';
export default postCore;
</script>
<style lang="less" scoped>
@import './index.less';
</style>
